interface ChevronRightProps {
    color?: string
    size?: number
  }
  
  function ChevronRight({color = "currentColor", size = 24}: ChevronRightProps) {
    return (
        <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="polymer-nav-mobile-dropdown__chevron-icon"
        aria-hidden
      >
        <path d="M9 6l6 6l-6 6" />
      </svg>
      
    )
  }
  
  export default ChevronRight